<template>
  <div class="Sidebar">
    <template>
      <div style="text-align:center;height:84.5px;background: #fff;width:100%">
        <img v-if="mainSystem" style="width:131px;height:40.7px;padding: 11.8px 0;padding-top: 24px;" :src="$store.state.imgsrc1" :style="{filter: gongjiri ? 'brightness(0)':'',opacity:gongjiri ? '50%':''}"/>
        <img style="width:131px;padding: 11.8px 0;padding-top: 24px;" src="../../../assets/wuhanzhongyan.png" 
         :style="{filter: gongjiri ? 'brightness(0)':'',opacity:gongjiri ? '50%':''}" v-else  />
        <!-- <img style="width:131px;padding: 11.8px 0;padding-top: 24px;" src="../../../assets/wuhanzhongyan.png" /> -->

      </div>
    </template>
    <!-- <div style="width:200px;color: #fff;height: 45px;text-align: left;line-height: 45px;padding-left:20px;cursor: pointer;background: ;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"> -->
    <div style="width:233px;color: #fff;height: 45px;text-align: left;line-height: 45px;
    padding-left:20px;cursor: pointer;box-sizing:border-box;
    overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :style="{background: gongjiri ? 'gray':'rgb(47,80,119)',color:gongjiri?'#fff':'#fff'}">

      <span>{{ title }}</span>
    </div>
    <div class="zy-main">
      <el-scrollbar :style="{'height':computedwidth}">

        <div class="zy-main__box">
          <transition name="move" mode="out-in">
            <el-menu :unique-opened="false" background-color="#fff"  router text-color="#000" active-text-color="#293c5c" :default-openeds="openeds" :default-active="$route.path"  class="lihai" >
              <Content v-on:projectName="addName" @zishuju="zishuju" ></Content>
            </el-menu>
          </transition>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Content from './Content'
export default {
  name: 'Sidebar',
  components: {
    Content
  },
  computed: {
    ...mapGetters([
      'mainSystem',
    ])
  },
  data() {
    return {
      title: null,
      gongjiri: false,
      openeds:[],
      computedwidth:'54vh'
     
    }
  },
  methods: {
     adjustLayout() {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      console.log(vw)
      if (vw < 1300) {
        // 小屏幕处理逻辑
        this.computedwidth = '20vh'
        console.log('ed')
      } else if (vw >= 1000 && vw < 1400) {
        // 中等屏幕处理逻辑
        this.computedwidth = '25vh'
        console.log('ed1')
      } else if (vw >= 1702 && vw < 1872) {

            this.computedwidth = '83vh'
        // 中等屏幕处理逻辑

      } else if (vw >= 1872 && vw < 2080) {
       this.computedwidth = '82vh'
      } else if (vw >= 2080 && vw < 2340) {
         this.computedwidth = '84vh'

      } else if (vw >= 2340 && vw < 2496) {
      
          this.computedwidth = '85vh'
        
        // this.computedwidth ='58vh'
      } else if (vw >= 2496 && vw < 2808) {
      
          this.computedwidth = '86vh'
       

      } else if (vw >= 2808 && vw < 3744) {

     
          this.computedwidth = '89vh'
       
      } else if (vw >= 3744 && vw < 5616) {
       
          this.computedwidth = '93vh'
        
        // 大屏幕处理逻辑
      } else {
       
          this.computedwidth = '84vh'
        }
        // this.computedwidth ='84vh'
      },
    addName: function (data) {
      this.title = data.title
      localStorage.setItem('nihao',this.title)
    },
    DateFormat() {
      let date = new Date(),
        currentDate,
        currentTime,
        seperator = "-", // 如果想要其他格式 只需 修改这里
        month = date.getMonth() + 1,
        day = date.getDate(),
        hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        minute =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
        second =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      month >= 1 && month <= 9 ? (month = "0" + month) : "";
      day >= 0 && day <= 9 ? (day = "0" + day) : "";
      //当前 日期
      currentDate = month + seperator + day;
      //当前 时间
      currentTime = hour + ":" + minute + ":" + second;
      // 输出格式 为 8-27 14:45:33
      return currentDate + " " + currentTime;
    },
    currenttime() {

      var nowTime = this.DateFormat();
      // 2.设置南京事件公祭日
      var NJ_country_startTime = "12-13 00:00:00";
      var NJ_country_overTime = "12-14 00:00:00";
      //2.设置汶川哀悼开始及结束 是 5月12号凌晨
      var earthquake_startTime = "05-12 00:00:00";
      var earthquake_overTime = "05-12 00:00:00";
      //3.设置汶川哀悼开始及结束 是 5月12号凌晨
      var earthquake1_startTime = "12-13 00:00:00";
      var earthquake1_overTime = "12-14 00:00:00";
      //在这判断时间，时间字符串可以直接判断大小，不过要精确到秒
      if (nowTime >= NJ_country_startTime && nowTime <= NJ_country_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true

      } else if (nowTime >= earthquake_startTime && nowTime <= earthquake_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true
      } else if (nowTime >= earthquake1_startTime && nowTime <= earthquake1_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true
      }

    },
    zishuju(r){
      console.log()
      console.log(r)
      this.openeds = r
    },
  },
  mounted() {
    this.currenttime()
    console.log(this.$store.state.imgsrc1)
  },
  created(){
    window.addEventListener('resize', this.adjustLayout);
    this.adjustLayout(); // 初始调用以应用样式
  }
}
</script>

<style scoped>
.Sidebar {
  min-width: 233px;
  background: #efeff3;
}
.zy-main {
  max-width: 233px;
  min-height: calc(100% - 181px);
  background: #fff;
}
.el-scrollbar {
  /* height: 756px; */
}

>>>  .el-menu-item.is-active {
  background-color: #cdd7e0 !important;
   /* color: #0d3a61 !important; */

} 
>>> .el-scrollbar__wrap {
  overflow: hidden !important;
  overflow-y: scroll !important;
}
>>> .el-menu {
  border: none !important;
}
>>> .el-menu-item,
.el-submenu__title {
  height: 50px !important;
}
</style>
<style>
 .lihai .el-menu-item.is-active {
  background-color: #cdd7e0 !important;
  /* color: #0d3a61 !important; */

} 

</style>




// WEBPACK FOOTER //
// src/components/Layout/Sidebar/Sidebar.vue